import React from 'react';
import cx from 'classnames';
import { CancelIcon } from '../../../icons/CancelIcon.js';
import styles from './index.module.scss.js';

const CloseButton = (props) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...props,
    className: cx(styles.close),
    type: "button",
    title: "Close",
    "aria-label": "Close"
  },
  /* @__PURE__ */ React.createElement(
    "svg",
    {
      width: "33",
      height: "32",
      viewBox: "0 0 33 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": true
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M16.8398 2C9.03984 2 2.83984 8.2 2.83984 16C2.83984 23.8 9.03984 30 16.8398 30C24.6398 30 30.8398 23.8 30.8398 16C30.8398 8.2 24.6398 2 16.8398 2ZM22.2398 23L16.8398 17.6L11.4398 23L9.83984 21.4L15.2398 16L9.83984 10.6L11.4398 9L16.8398 14.4L22.2398 9L23.8398 10.6L18.4398 16L23.8398 21.4L22.2398 23Z",
        fill: "currentColor"
      }
    )
  )
);
CloseButton.displayName = "CloseButton";
const CloseButton2 = (props) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...props,
    type: "button",
    title: "Close",
    "aria-label": "Close",
    className: cx(styles["close-2"], props?.className)
  },
  /* @__PURE__ */ React.createElement(CancelIcon, null)
);
CloseButton2.displayName = "CloseButton2";

export { CloseButton, CloseButton2 };
//# sourceMappingURL=index.js.map
